module.exports = __webpack_public_path__ + "static/splash-eubank-xl-60c245304fd1dd4f4768492a32accc52.jpg";